<template>
  <div class="cart_button">
    <p v-if="!product.preorder && product.stock && !inCart">
      <a
        id="buy-in-one-click"
        class="kupit pum-trigger buy-one-click-product"
        style="cursor: pointer"
        @click.stop.prevent="onQuickOrder"
        v-if="!product.preorder && product.stock && !inCart"
      >
        {{ $t('buyOneClick') }}
      </a>
    </p>
    <p v-if="product.stock && !inCart && !product.preorder">
      <button
        type="button"
        name="add-to-cart"
        class="single_add_to_cart_button button alt"
        @click.stop.prevent="onAddToCart"
        v-if="product.stock && !inCart && !product.preorder"
      >
        {{ $t('addToCart') }}
      </button>
    </p>
    <p v-if="product.preorder">
      <a
        id="preorder-click"
        class="kupit pum-trigger"
        style="cursor: pointer"
        @click.stop.prevent="onPreOrder"
        v-if="product.preorder"
      >
        {{ $t('preorder') }}
      </a>
    </p>
    <router-link
      id="add-to-cart-button"
      to="/cart"
      class="kupit pum-trigger"
      :title="$t('showCart')"
      v-if="!product.preorder && product.stock && inCart"
    >
      {{ $t('showCart') }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'CartButtons',
  props: {
    product: {
      type: Object,
      require: true,
      default: () => ({}),
    },
    onQuickOrder: Function,
    onAddToCart: Function,
    onPreOrder: Function,
    inCart: Boolean,
  },
}
</script>
